import { Component, Input } from '@angular/core';
import { MessageService } from '../../services/message.service';
import { Router } from '@angular/router';
import { TourStop } from '../../models/tour-stop';
import { AppUrls } from '../../app.urls';
import { TourService } from '../../services/tour.service';

@Component({
  selector: 'app-tour-stop-card',
  templateUrl: './tour-stop-card.component.html',
  styleUrls: ['./tour-stop-card.component.scss']
})
export class TourStopCardComponent {

  @Input() tourStop: TourStop;

  constructor(
    private router: Router,
    private messageService: MessageService,
    private tourService: TourService
  ) {
  }

  get hasNotification(): boolean {
    return this.messageService.hasNotification;
  }

  /**
   * Show the tour stop details.
   * The UI should be blocked if there's a notification that must be marked as read, so the details should not be shown
   * in that case.
   * Transport orders must be started if were shown by a tap, so it's specifically set to require the start code.
   */
  open(): void {
    if (!this.hasNotification) {
      if (this.tourStop.isTransport) {
        this.tourService.currentTransport = this.tourStop.transport;
        this.tourService.needsTransportStartCode = true;
        this.router.navigate([AppUrls.ROOT, AppUrls.TransportDetails]);
      } else if (this.tourStop.isHomeDelivery) {
        this.router.navigate([AppUrls.ROOT, AppUrls.HomeDeliveryDetails], {
          state: {
            homeDelivery: this.tourStop.homeDelivery.raw
          }
        });
      }
    }
  }
}
